<template>
    <div id="calendar" class="page">
        <h2>Kalender</h2>
        <div class="alert alert-info" role="alert">
            <strong>Uitleg.</strong> Middels deze kalender kunt u per dag aangeven of u beschikbaar bent en tegen welk tarief (indien afwijkend van uw standaard tarief). Uw standaard tarieven vind u <router-link tag="a" :to="{ name: 'ProfessionalProfileRates'}">hier</router-link>.
        </div>
        <calendar></calendar>
    </div>
</template>

<script>
import Calendar from '@/components/Calendar'
export default {
    components: {
        Calendar,
    }
}
</script>

<style scoped>
</style>